/* import __COLOCATED_TEMPLATE__ from './color-picker.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { ColorPickerType, ColorPickerApplyMode } from '@intercom/embercom-prosemirror-composer/components/utils/constants';
let ColorPicker = (_class = class ColorPicker extends Component {
  get selectedColor() {
    let color;
    if (this.args.type === ColorPickerType.TEXT) {
      color = this.args.applyMode === ColorPickerApplyMode.SELECTION ? this.getColorFromSelection() : this.args.composer.state.selectionAnchorNodeFontColor;
    } else if (this.args.type === ColorPickerType.BUTTON) {
      color = this.args.composer.state.selectionAnchorNodeBackgroundColor;
    }
    return color || '#000000';
  }
  onChangeColor(newColor) {
    if (!this.args.composer || newColor === this.selectedColor) {
      return;
    }
    if (this.args.type === ColorPickerType.TEXT) {
      if (this.args.applyMode === ColorPickerApplyMode.SELECTION) {
        this.args.composer.commands.addMarkType('span', {
          style: `color: ${newColor}`
        });
      } else {
        this.args.composer.commands.styling.updateFontColor(newColor, true);
      }
    } else if (this.args.type === ColorPickerType.BUTTON) {
      this.args.composer.commands.styling.updateBackgroundColor(newColor);
    }
    this.args.composer.commands.focus();
  }
  getColorFromSelection() {
    let color = '';
    let marks = this.args.composer.state.selectionNodeMarks;
    let spanMark = marks.find(mark => mark.type === this.args.composer.schema.marks.span);
    if (spanMark) {
      let colorStyle = spanMark.attrs?.style?.split(';').find(style => style.includes('color'));
      color = colorStyle?.split(': ')[1];
    }
    return color;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onChangeColor", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChangeColor"), _class.prototype)), _class);
export { ColorPicker as default };